import React from 'react';
import { useHistory } from 'react-router';

import { Props } from './ClientError.types';
import { Styled } from './ClientError.styles';

export const ClientError: React.FC<Props> = ({ error, onClose }) => {
  const history = useHistory();
  if (!error) {
    return null;
  }

  const onReturn = () => {
    history.push('/')
    onClose();
  }
  return (
    <div>
      <h1>Ошибка: {error.message}</h1>
      <button onClick={onReturn}>Вернуться</button>
      <p>{error.name}</p>
      <p>{JSON.stringify(error.componentStack)}</p>
      <p>{JSON.stringify(error.stack)}</p>
    </div>
  );
};
